import { Component } from "@angular/core";

@Component({
  selector: "newsletter-svg-sprite",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="unsubscribeIcon" viewBox="0 0 20 19" fill="none">
        <path
          d="M8.425 15.6886H1V1M1 1H17.425M1 1L9.4 9.35088L17.425 1M17.425 1V7.85965M11.8 16.7325L17.725 10.8421M19 13.75C19 16.0972 17.086 18 14.725 18C12.364 18 10.45 16.0972 10.45 13.75C10.45 11.4028 12.364 9.5 14.725 9.5C17.086 9.5 19 11.4028 19 13.75Z"
          stroke="#2973E0"
          stroke-width="1.2"
        />
      </symbol>
    </svg>
  `,
})
export class NewsletterSvgSpriteComponent {}
